<template>
    <div ref="orTable" class="or-table" v-loading="loading"  element-loading-text="拼命加载中">
        <el-row class="pl-table-header">
            <el-checkbox v-model="checked" :indeterminate="isIndeterminate" @change="handleCheckAll" class="pl-check-all">全选</el-checkbox>
            <el-col :span="item.span" v-for="item in columns" :key="item.id" >
                {{ item.label }}
            </el-col>
        </el-row>

        <div class="pl-table-column" v-for="(row,$index) in dataSource" :key="$index">
            <el-row class="pl-handle">
                <el-col :span="1"><el-checkbox v-model="row.check" @change="handleCheckChange($event,row)"></el-checkbox></el-col>
                <el-col :span="5">订单编号：{{ row.order_id }}</el-col>
                <el-col :span="5">原评价时间：{{ row.comment_time | dataTime }}</el-col>
                <el-col :span="5">下单时间：{{ row['ys_order.create_time'] | dataTime}}</el-col>
                <el-col :span="5">订单完成时间：{{ row['ys_order.finish_time'] | dataTime }}</el-col>
                <el-col :span="2">
                    <el-button type="text" size="small" style="padding: 0px;" @click.native="operation(row)" 
                    :style="{ display: myUserInfo.role_flag !== 3 && myUserInfo.role_flag !== 4 && myUserInfo.role_flag !== 5?'':'none' }">回  访</el-button>
                    <el-button type="text" size="small" style="padding: 0" @click.native="deliverGoods(row)">更  新</el-button>
                </el-col>
            </el-row>
            <el-row class="pl-border-bottom">
                <el-col v-for="(item,i) in columns" :key="i" :span="item.span">
                    <div class="cell">
                        <el-slot v-if="item.render" :render="item.render" :row="row" :index="$index" :column="item"/>
                        <span v-else>{{ row[item.prop] }}</span>
                    </div>
                </el-col>
            </el-row>
            
        </div>
        <div v-if="tableData.length === 0" class="pl-table__empty-block">暂无数据</div>
        
    </div>
</template>

<script>
import { format } from "@/utils/comm";
import { mapState } from "vuex"
var ele;
let elSlot = {
    functional: true,
    props: {
        row: Object,
        render: Function,
        index: Number,
        column: {
            type: Object,
            default: null
        }
    },
    render: (h, data) => {
        const params = {
            row: data.props.row,
            index: data.props.index
        }
        if (data.props.column) params.column = data.props.column
        return data.props.render(h, params)
    }
}
export default {
    props:{
        loading: Boolean, //表格加载
        columns: Array, //显示列
        tableData: Array, //表格数据 
        isKey: { //表格key
            type: String,
            default: 'order_id'
        },
        getCheckboxProps: Function
    },
    components:{
        elSlot
    },
    data() {
        return {
            isFixed: false,
            eleWidth: 0,
            eleLeft: 0,
            checked: false,
            multipleSelectionAll: [], // 所有选中的数据包含跨页数据
            multipleSelection: [], //当前页选中数据，
            successCss:"background-color: #f0f9eb;border-color: #e1f3d8;color: #67c23a;",
            failCss:"background-color: #fef0f0;border-color: #fde2e2;color: #f56c6c;"}
    },
    mounted(){
        window.addEventListener('scroll', this.handleScroll, false)
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll, false)
    },
    computed: {
        //计算列表数据
        dataSource(){
            let selectIds = []
            let idKey = this.isKey
            this.multipleSelectionAll.forEach(item => {
                selectIds.push(item[idKey])
            })
            let dataSource = this.tableData.filter(item => {
                item['check'] = selectIds.includes(item[idKey]) ? true : false
                return item
            })
            return dataSource
        },
        isIndeterminate(){
            if(this.multipleSelectionAll.length <= 0){
                return false
            }
            let selectIds = []
            let idKey = this.isKey
            this.multipleSelectionAll.forEach(item => {
                selectIds.push(item[idKey])
            })
            let num = 0
            this.tableData.forEach(item => {
                if(selectIds.includes(item[idKey])){
                    num++
                }
            })
            return num !== this.tableData.length
        },
        ...mapState({
			myUserInfo: state => state.app.userInfo
		}),
        
    },
    methods:{
        //滑动固定表头
        handleScroll(){
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
            let offsetTop = this.$refs.orTable.offsetTop - 60
            if(scrollTop >= offsetTop){
                let { x, width } = this.$refs.orTable.getBoundingClientRect();
                this.eleLeft = x;
                this.eleWidth = width;
                this.isFixed = true;
            }else{
                this.isFixed = false
            }
        },
        //操作事件
        operation(row){ //子传父 函数
            this.$emit("remark-by-orderId", row);
        },
        //更新
        deliverGoods(row){
            this.$emit('update-order-status-ByOrderId', row)
        },
        //单选
        handleCheckChange($event,row){
            let idKey = this.isKey
            if($event){
                this.multipleSelectionAll.push(row)
            }else{
                this.multipleSelectionAll = this.multipleSelectionAll.filter(item => item[idKey] !== row[idKey])
            }
            this.getAllSelectionData()
        },
        //全选
        handleCheckAll($event){
            let idKey = this.isKey
            if($event){
                // 如果总记忆中还没有选择的数据，那么就直接取当前页选中的数据
                if(this.multipleSelectionAll.length <= 0){
                    this.multipleSelectionAll = this.tableData
                }else{
                    // 总选择里面的key集合
                    let multipleSelection = []
                    this.multipleSelectionAll.forEach(item => {
                        multipleSelection.push(item[idKey])
                    })
                    for(let i = 0; i < this.tableData.length; i++){
                        if(!multipleSelection.includes(this.tableData[i][idKey])){
                            this.multipleSelectionAll.push(this.tableData[i])
                        }
                    }
                }
            }else{
                let selectIds = []
                this.tableData.forEach(item => {
                    selectIds.push(item[idKey])
                })
                this.multipleSelectionAll = this.multipleSelectionAll.filter(item => !selectIds.includes(item[idKey]))
            }
            this.getAllSelectionData()
        },
        //得到选中数据
        getAllSelectionData(){
            this.$emit('selection-change', this.multipleSelectionAll)
        },
        //分页后，更新全选勾选状态
        changeAllCheckStatus(){
            if(this.multipleSelectionAll.length <= 0){
                this.checked = false
                return
            }
            let idKey = this.isKey
            let num = 0
            let selectIds = []
            this.multipleSelectionAll.forEach(item => {
                selectIds.push(item[idKey])
            })
            this.tableData.forEach(item => {
                if(selectIds.includes(item[idKey])){
                    num++
                }
            })
            this.checked = num === this.tableData.length
        },
        //清除勾选
        clearSelection(){
            this.multipleSelectionAll= []
            this.getAllSelectionData()
        },
        //数组对象去重
        reduceSame(arr){
            let obj = {}
            return arr.reduce((prev, item, index) => {
                obj[item[this.isKey]] ? "" : (obj[item[this.isKey]] = 1 && prev.push(item))
                return prev
            }, [])
        },
        //数组对象删除相同
        reduceDel(arr){
            let isKey = this.isKey
            this.tableData.forEach(item => {
                this.multipleSelectionAll.some((el,index) => {
                    if(item[isKey] === el[isKey]){
                        this.multipleSelectionAll.splice(index,1)
                        return true
                    }
                    return false
                })
            })
        },
        //回访状态
        creturnVisitFlag(row){
            let tag = true;
            if(row.creturn_visit_flag !== null){
                if(row.creturn_visit_flag !== 1)
                    tag = false
            }
            return tag;
        }
    },
    watch: {
        tableData(){
            this.changeAllCheckStatus()
        }
    },
    filters:{
        dataTime(val){
            if(val == "1970-01-01T00:00:00.000Z" || !val) return '--';
			return format(val);
        }
    }
}
</script>

<style lang="scss">
.or-table{
    position: relative;
    box-sizing: border-box;
    font-size: 12px;
    color: #495060;
    text-align: center;
    margin-top: 10px; 
    .pl-table-header{
        position: sticky;
        top: 60px;
        // padding: 12px 0;
        z-index: 97;
        box-sizing: border-box;
        background: #e9eaec;
        .el-col{
            line-height: 40px;
        }
        .pl-check-all{
            position: absolute;
            top: 12px;
            left: 6px;
            .el-checkbox__label{
                font-size: 12px;
                padding-left: 4px;
            }
        }
        .caret-wrapper{
            display: inline-flex;
            flex-direction: column;
            align-items: center;
            height: 34px;
            width: 24px;
            vertical-align: middle;
            cursor: pointer;
            overflow: initial;
            position: relative;
        }
        .caret{
			width: 0;
    		height: 0;
    		border: 5px solid transparent;
    		position: absolute;
    		left: 7px;
		}
		.ascending{
			border-bottom-color: #c0c4cc;
    		top: 5px;
		}
		.descending{
			border-top-color: #c0c4cc;
    		bottom: 7px;
		}
        .asc{
			.ascending{
				border-bottom-color: #409eff;
			}
		}
		.desc{
			.descending{
				border-top-color: #409eff;
			}
		}
    }
    .pl-table-column{
        position: relative;
        margin-top: 18px;
        border-top: 1px solid #e9eaec;
        .pl-handle-success{
            padding: 12px;
            background-color: #f0f9eb;
            border-color: #e1f3d8;
            color: #67c23a;
        }
        .pl-handle-fail{
            padding: 12px;
            background-color: #fef0f0;
            border-color: #fde2e2;
            color: #f56c6c;
        }
        .pl-handle{
            padding: 12px;
            background: #e9eaec;
            text-align: left;
        }
        .cell{
            padding: 6px;
            line-height: 18px;
            box-sizing: border-box;
            white-space: normal;
            word-break: break-all;
            text-overflow: ellipsis;
            text-align: left;
            p{
                margin: 0 0 4px 0;
            }
        }
    }
    .pl-table__empty-block{
        text-align: center;
        line-height: 60px;
        // min-height: 60px;
        border-bottom: 1px solid #e9eaec;
        color: #909399;
    }
    .pl-border-bottom{
        border-bottom: 1px solid #e9eaec;
    }
}
</style>